import React, { useState, useEffect, useMemo } from 'react'
import NavBar from '../../components/NavBar/NavBar';
import SmallNavBar from '../../components/SmallNavBar/SmallNavBar';
import { useNavigate, useLocation } from 'react-router-dom';
function Menu({ items, userType, bailleurId }) {
  const [activeNav, setActiveNav] = useState(localStorage.getItem('activeNavBar') || 'navBar');
  const [activeNavLink, setActiveNavLink] = useState(localStorage.getItem('activeNavLink') || '');
  let location = useLocation();

  const pathtems = useMemo(() => (
    [
      { path: '/' },
      { path: '/suiviEnquetes' },
      { path: '/suiviEnquetesToControle' },
      { path: '/reception' },
      { path: '/controleEnquete' },
      { path: '/kpi' },
      { path: '/suiviEnquete' },
      { path: '/saisieExterne' },
      { path: '/retourBailleur' },
      { path: '/declaration' },
      { path: '/gestionAccesExterns' },
      { path: '/modeMaintenance' },
      { path: '/documentation' },
      { path: '/importFichier' },
      { path: '/exportComposition' }, 
      { path: '/entitiesManager' },
      { path: '/exportRestitution' },
      { path: '/emailsSettings' },
      { path: '/tools' },
      { path: '/usersManager' },
          { path: '/entity/' + bailleurId } 

    ]
  ), [])


  useEffect(() => {

    let exist = pathtems.some(item => item.path == location.pathname)

    if (exist) {
      localStorage.setItem('activeNavLink', location.pathname);
      setActiveNavLink(location.pathname)
    }

  }, [location.pathname])

  const toggleNav = () => {
    switch (activeNav) {
      case 'navBar':
        localStorage.setItem('activeNavBar', 'smallNavBar');
        setActiveNav('smallNavBar');
        break;
      case 'smallNavBar':
        localStorage.setItem('activeNavBar', 'navBar');
        setActiveNav('navBar');
        break;
      default:
        break;
    }
  }

  return (
    <>
      {
              activeNav === 'navBar' ?
                  <NavBar userType={userType} activeNavLink={activeNavLink} setActiveNavLink={setActiveNavLink} toggleNav={toggleNav} items={items} /> :
                  <SmallNavBar activeNavLink={activeNavLink} setActiveNavLink={setActiveNavLink} toggleNav={toggleNav} items={items} />
      }
    </>
  )
}

export default Menu